/* eslint-disable jira/filename-case */
import { defineMessage } from '@atlassian/jira-intl';
import type { Cards, TaskList } from '../../../../common/types.tsx';
import {
	PLAN_TEAM_CAPACITY_TASK,
	PLAN_PROGRAM_BOARD_TASK,
	PLAN_RELEASE_MANAGEMENT_TASK,
	PLAN_DEPENDENCY_TRACKING_TASK,
} from '../../../../common/constants.tsx';
import { Feature } from '../tailored-onboarding/constants.tsx';

const rootTitle = defineMessage({
	id: 'onboarding-quickstart-core.services.tasks.config.plan.root-title',
	defaultMessage: 'Quickstart',
	description: 'Initial title of Quickstart for Jira Plan',
});

export const PLAN_TASK_LIST: TaskList = Object.freeze({
	root: {
		title: rootTitle,
		items: [
			PLAN_TEAM_CAPACITY_TASK,
			PLAN_PROGRAM_BOARD_TASK,
			PLAN_RELEASE_MANAGEMENT_TASK,
			PLAN_DEPENDENCY_TRACKING_TASK,
		],
	},
});

export const PLAN_TASK_VARIANTS: Cards = {
	[PLAN_TEAM_CAPACITY_TASK]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasPlanTeams],
					value: true,
				},
			],
		},
	},
	[PLAN_PROGRAM_BOARD_TASK]: {
		position: { default: 10 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasPlanProgram],
					value: true,
				},
			],
		},
	},
	[PLAN_RELEASE_MANAGEMENT_TASK]: {
		position: { default: 20 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasPlanReleases],
					value: true,
				},
			],
		},
	},
	[PLAN_DEPENDENCY_TRACKING_TASK]: {
		position: { default: 30 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasPlanDependencies],
					value: true,
				},
			],
		},
	},
};
